export const USERS_BASE_PATH = 'users';
export const CREATE_USER_PATH = 'users/create';
